import { ROUTES, isPrivateConnectionsPath } from '@/shared/constants/routes';
import type { DatasetCrumbContext, ScopeCrumbs } from '@/viewmodel/features/project/types';
import type { BreadcrumbItem } from '@/viewmodel/shared/breadcrumbs';
import type { TFunction } from 'i18next';

export function authenticatedBreadcrumbs(
  pathname: string,
  crumbs: ScopeCrumbs,
  t: TFunction,
): BreadcrumbItem[] {
  if (pathname === ROUTES.PROJECTS) {
    return [crumbs.workspace(ROUTES.WORKSPACES), { label: t('projects.title') }];
  }
  if (pathname === ROUTES.SETTINGS) {
    return [crumbs.workspace(ROUTES.PROJECTS), crumbs.project, { label: t('header.settings') }];
  }
  return [{ label: t('workspaces.title') }];
}

function privateConnectionsCrumbs(
  pathname: string,
  crumbs: ScopeCrumbs,
  t: TFunction,
): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [
    crumbs.workspace(ROUTES.PROJECTS),
    { label: t('privateConnections.title'), href: ROUTES.PRIVATE_CONNECTIONS },
  ];
  if (pathname === ROUTES.PRIVATE_CONNECTION_CREATE) {
    items.push({ label: t('privateConnections.create.title') });
  } else if (pathname !== ROUTES.PRIVATE_CONNECTIONS) {
    items.push({ label: t('privateConnections.detail.title') });
  }
  return items;
}

export function datasetBreadcrumbs(
  pathname: string,
  { isCreateMode, currentPageLabel }: DatasetCrumbContext,
  crumbs: ScopeCrumbs,
  t: TFunction,
): BreadcrumbItem[] {
  if (isPrivateConnectionsPath(pathname)) return privateConnectionsCrumbs(pathname, crumbs, t);
  if (pathname === ROUTES.REPORTS) {
    return [crumbs.workspace(ROUTES.PROJECTS), { label: t('reports.title') }];
  }
  if (pathname === ROUTES.MCP) {
    return [
      { label: t('header.settings'), href: ROUTES.SETTINGS },
      { label: t('dataset.sidebar.mcp') },
    ];
  }
  if (pathname === ROUTES.BILLING) {
    return [crumbs.workspace(ROUTES.PROJECTS), crumbs.project, { label: t('billingPage.title') }];
  }
  const pageLabel = currentPageLabel ?? t('dataset.sidebar.datasources');
  const scope = [crumbs.workspace(ROUTES.PROJECTS), crumbs.project];
  return isCreateMode
    ? [...scope, { label: pageLabel, href: pathname }, { label: t('dataset.form.newConnection') }]
    : [...scope, { label: pageLabel }];
}
